import { objectKeys } from "app/helpers/objects";
import { signalTypeMap } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { SignalSource, SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

import type CountPerSignalType from "../../miscellaneous/CountPerSignalType";
import type SignalsService from "../../services/SignalsService";
import createSignalTypesListViewModel from "../signal-types-list/factory";
import type UISignalsGroupedByType from "../UISignalsGroupedByType";

import type SignalsManagementViewModel from "./SignalsManagementViewModel";

type FactoryDeps = {
    signalsByType: Readonly<UISignalsGroupedByType> | null;
    signalsService: SignalsService;
    signalSource: SignalSource;
};

export default function createSignalsManagementViewModel(deps: FactoryDeps): Readonly<SignalsManagementViewModel> {
    const { signalsByType, signalsService, signalSource } = deps;
    const signalTypesListViewModel = createSignalTypesListViewModel({ signalsService, signalSource });
    const initialCountPerSignalType = Object.values(signalTypeMap).reduce((group, signalType: SignalType) => {
        group[signalType] = 0;

        return group;
    }, {} as CountPerSignalType);

    return {
        ...signalTypesListViewModel,
        get signalsCountPerType() {
            if (signalsByType === null) {
                return undefined;
            }

            return objectKeys(signalsByType).reduce((group, signalType: SignalType) => {
                group[signalType] = signalsByType[signalType].length;

                return group;
            }, initialCountPerSignalType);
        },
        get signalSource() {
            return signalSource;
        },
        getUISignalsOfType(signalType: SignalType) {
            return signalsByType?.[signalType] ?? [];
        },
    };
}
